<template>
  <div class="conversations">
    <button
      type="button"
      class="conversations__new"
      :disabled="disabled"
      @click="$emit('new')"
    >
      <i class="mdi mdi-plus"></i> Nueva conversación
    </button>

    <p v-if="loading" class="conversations__hint">Cargando…</p>
    <p v-else-if="error" class="conversations__error">{{ error }}</p>
    <p v-else-if="!conversations.length" class="conversations__hint">
      Todavía no hay conversaciones guardadas en esta tienda.
    </p>

    <ul v-else>
      <li
        v-for="conversation in conversations"
        :key="conversation.id"
        :class="{ 'is-current': Number(conversation.id) === currentId }"
      >
        <template v-if="confirmingId === conversation.id">
          <span class="conversations__title">¿Borrar esta conversación?</span>
          <button
            type="button"
            class="conversations__danger"
            @click="remove(conversation.id)"
          >
            Borrar
          </button>
          <button type="button" @click="confirmingId = null">Cancelar</button>
        </template>
        <template v-else>
          <button
            type="button"
            class="conversations__open"
            :disabled="disabled"
            @click="$emit('open', Number(conversation.id))"
          >
            <span class="conversations__title">
              {{ conversation.title || "Sin título" }}
            </span>
            <span class="conversations__date">
              {{ formatDate(conversation.updatedAt) }}
            </span>
          </button>
          <button
            type="button"
            title="Borrar"
            :disabled="disabled"
            @click="confirmingId = conversation.id"
          >
            <i class="mdi mdi-delete-outline"></i>
          </button>
        </template>
      </li>
    </ul>
  </div>
</template>

<script>
// Conversaciones guardadas del usuario en la tienda actual
export default {
  name: "ConversationList",
  props: {
    conversations: { type: Array, required: true },
    currentId: { type: Number, default: null },
    loading: { type: Boolean, default: false },
    error: { type: String, default: null },
    // Mientras Claude responde no se cambia de conversación
    disabled: { type: Boolean, default: false }
  },
  data() {
    return { confirmingId: null };
  },
  methods: {
    remove(id) {
      this.confirmingId = null;
      this.$emit("remove", Number(id));
    },
    // "2026-10-24 08:37:13" del API, hora del servidor
    formatDate(value) {
      const date = new Date(String(value).replace(" ", "T"));
      if (isNaN(date)) return value;
      return date.toLocaleString(undefined, {
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.conversations {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 13px;
}
.conversations__new {
  align-self: flex-start;
  padding: 6px 10px;
  border-radius: 6px;
  background: #1f2937;
  color: white;
  font-weight: 600;
  &:disabled {
    opacity: 0.5;
  }
}
.conversations__hint {
  color: #6b7280;
}
.conversations__error {
  color: #b91c1c;
}
li {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: white;
  & + li {
    margin-top: 6px;
  }
  &.is-current {
    border-color: #2563eb;
    background: #eff6ff;
  }
  button:disabled {
    opacity: 0.5;
  }
}
.conversations__open {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}
.conversations__title {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
// En la columna del botón (align-items: flex-start) el título tomaría el
// ancho de su texto y se saldría; con el del botón se corta con "…"
.conversations__open .conversations__title {
  display: block;
  width: 100%;
}
.conversations__date {
  font-size: 11px;
  color: #6b7280;
}
.conversations__danger {
  color: #b91c1c;
  font-weight: 600;
}
</style>
